import { useEffect, useCallback, ReactNode } from 'react';

interface MobileInfoPopupProps {
  className?: string;
  children: ReactNode;
  open: boolean;
  setOpen: (open: boolean) => void;
  clickClose?: () => void;
}

const MobileInfoPopup = ({ className = "", children, open, setOpen, clickClose }: MobileInfoPopupProps) => {

	const onClick = useCallback(() => {
		if (clickClose) {
			clickClose();
		} else {
			setOpen(false);
		}
	}, [clickClose, setOpen]);

	// Handle ESC key press
	useEffect(() => {
		const handleEsc = (event: KeyboardEvent) => {
			if (event.key === 'Escape') {
				onClick();
			}
		};

		if (open) {
			document.addEventListener('keydown', handleEsc);
		}

		return () => {
			document.removeEventListener('keydown', handleEsc);
		};
	}, [open, onClick]);

	return (
		<>
			<div
				className={`mobile-info-popup-close ${open ? "open" : ""}`}
				onClick={onClick}
			/>
			<div
				className={`mobile-info-popup ${className} same-color ${
					open ? "open" : ""
				}`}
			>
				{children}
			</div>
		</>
	);
};

export default MobileInfoPopup;
